import styled from 'styled-components'

import { media } from '../../../styles/breakpoints'

export const MainPanelBar = styled.div`
  display: flex;
  background-color: #fff;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 16px;
  padding: 16px 0;

  @media ${media.belowTablet} {
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 0;
  }
`
MainPanelBar.displayName = 'MainPanelBar'
